/* eslint-disable no-useless-escape */
import React from 'react';
import { Button, Col, Form, Input, InputNumber, Row, message } from 'antd';
import { Download, EditIcon } from 'lucide-react';
import TextArea from 'antd/es/input/TextArea';
import useSWR from 'swr';
import { ComparativeVehicleContainer } from './appraisal';
import { downloadPDF, currencyFormatter, currencyParser, parser, formatter } from '../../utils';
import { ValuationApi } from '../../apis';
import { useNavigate } from 'react-router-dom';

const LoanOfficer = () => {
  const { data: payload } = useSWR('swr.valuation.payload');
  const navigate = useNavigate();

  if (payload && payload.status === 'REJECTED') {
    return <div></div>;
  }

  // if (payload && payload.status === 'VALUATED') {
  //   return (
  //     <div className="h-[99px] w-[100%] absolute border z-[100] bottom-0 left-0 bg-[white] flex flex-row justify-end items-center pr-[21px] gap-[20px]">
  //       <Button
  //         type="primary"
  //         size="large"
  //         icon={<Download className="w-[20px] h-[20px]" color="white" />}
  //       >
  //         PDF татах
  //       </Button>
  //     </div>
  //   );
  // }

  console.log('PAYLOAD =>', payload);

  if (
    (payload?.comparativeVehicles || []).length === 0 &&
    payload &&
    payload.status === 'PENDING'
  ) {
    return (
      <div className="h-[99px] w-[100%] absolute border z-[100] bottom-0 left-0 bg-[white] flex flex-row justify-end items-center pr-[21px] gap-[20px]">
        {/* <Button
          type="primary"
          size="large"
          icon={<Download className="w-[20px] h-[20px]" color="white" />}
        >
          PDF татах
        </Button> */}
      </div>
    );
  }

  const downloadReport = async () => {
    try {
      const res = await ValuationApi.pdf(payload?.id);
      downloadPDF(res.url);
    } catch (error: any) {
      message.error(error?.message || 'PDF татахад алдаа гарлаа');
    }
  };

  const onEdit = async () => {
    navigate(`/sendvaluation/${payload?.id}`);
  };

  if (payload.status === 'DRAFT') {
    return <div></div>;
  }

  if (
    (payload?.comparativeVehicles || []).length === 0 &&
    payload &&
    payload.status !== 'PENDING' &&
    payload.status !== 'RETURNED'
  ) {
    return (
      <div className="h-[99px] w-[100%] absolute border z-[100] bottom-0 left-0 bg-[white] flex flex-row justify-end items-center pr-[21px] gap-[20px]">
        <Button
          type="primary"
          size="large"
          icon={<Download className="w-[20px] h-[20px]" color="white" />}
          onClick={downloadReport}
        >
          PDF татах
        </Button>
      </div>
    );
  }

  if (payload && payload?.status === 'RETURNED') {
    return (
      <div className="h-[99px] w-[100%] absolute border z-[100] bottom-0 left-0 bg-[white] flex flex-row justify-end items-center pr-[21px] gap-[20px]">
        <Button
          type="primary"
          size="large"
          icon={<EditIcon className="w-[20px] h-[20px]" color="white" />}
          onClick={onEdit}
        >
          Засах
        </Button>
      </div>
    );
  }

  return (
    <>
      <div className="px-[20px]">
        <Form layout="vertical" disabled>
          <div>
            {(payload?.comparativeVehicles || [])?.length > 0 && (
              <div className="flex flex-row justify-between items-center p-[17px]">
                <div className="font-bold text-[20px] leading-[44px] tracking-[0px] text-[#282830]">
                  Үнэлгээчийн харьцуулсан загварын автомашинууд
                </div>
              </div>
            )}

            {(payload?.comparativeVehicles || [])?.length > 0 && (
              <div className="flex flex-wrap gap-4 px-[20px]">
                {(payload?.comparativeVehicles || []).map((item: any, index: number) => {
                  return (
                    <ComparativeVehicleContainer
                      key={index}
                      className="border border-[#F1F5F9] rounded-[14px]"
                    >
                      <div className="p-[17px]">
                        <div className="border-[#F1F5F9] rounded-[14px]">
                          {/* ------- Grid Row 1 ------- */}
                          <div className="grid grid-cols-2 gap-3">
                            <div>
                              <div className="text-sm mb-1">Автомашины брэнд</div>
                              <Input
                                value={item.brandModel}
                                size="large"
                                placeholder="Toyota Camry"
                                style={{ width: '100%' }}
                              />
                            </div>

                            <div>
                              <div className="text-sm mb-1">Үйлдвэрлэсэн он*</div>
                              <Input
                                size="large"
                                value={item?.manufacturedYear}
                                placeholder="2020"
                                style={{ width: '100%' }}
                              />
                            </div>
                          </div>

                          {/* ------- Grid Row 2 ------- */}
                          <div className="grid grid-cols-2 gap-3 mt-4">
                            <div>
                              <div className="text-sm mb-1">Гүйлт (км)*</div>
                              <InputNumber
                                size="large"
                                placeholder="45000"
                                style={{ width: '100%' }}
                                value={item?.odo}
                                parser={parser}
                                formatter={formatter as any}
                              />
                            </div>

                            <div>
                              <div className="text-sm mb-1">Зах зээлийн үнэ (₮)</div>
                              <InputNumber
                                size="large"
                                placeholder="Зах зээлийн үнэ"
                                formatter={currencyFormatter}
                                parser={currencyParser}
                                style={{ width: '100%' }}
                                value={item?.price}
                              />
                            </div>
                          </div>

                          {/* ------- Grid Row 3 ------- */}
                          <div className="grid grid-cols-2 gap-3 mt-4">
                            <div>
                              <div className="text-sm mb-1">Эх сурвалж*</div>
                              <Input
                                size="large"
                                placeholder="unegui.mn"
                                style={{ width: '100%' }}
                                value={item?.sourceUrl}
                              />
                            </div>

                            <div>
                              <div className="text-sm mb-1">Орж ирсэн он</div>
                              <Input
                                size="large"
                                placeholder="2020"
                                value={item?.importedYear}
                                style={{ width: '100%' }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </ComparativeVehicleContainer>
                  );
                })}

                <div className="sm:w-[580px] md:w-[580px] lg:w-[580px] xl:w-[580px] 2xl:w-[580px]">
                  <div className="border border-[#F1F5F9] rounded-[14px] p-[27px] w-[70%]">
                    <div className="font-manrope font-bold text-[18px] leading-[44px] tracking-[0px] text-[#282830] flex flex-row justify-center">
                      Үнэлгээний дүгнэлт
                    </div>
                    <div className="h-[10px]" />
                    <Row gutter={16}>
                      <Col span={24} key="priceFinal">
                        <Form.Item label="Үнэлгээчний үнэлгээ">
                          <InputNumber
                            value={payload?.priceFinal}
                            placeholder="Үнэлгээчний үнэлгээ"
                            style={{ width: '100%' }}
                            formatter={currencyFormatter}
                            parser={currencyParser}
                          />
                        </Form.Item>
                      </Col>

                      <Col span={24} key="conclusion">
                        <Form.Item label="Үнэлгээний дүгнэлт">
                          {payload?.conclusion && (
                            <TextArea
                              value={payload?.conclusion}
                              placeholder="Үнэлгээний дүгнэлт"
                              style={{ width: '100%' }}
                            />
                          )}
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Form>
      </div>

      <div className="h-[99px] w-[100%] absolute border z-[100] bottom-0 left-0 bg-[white] flex flex-row justify-end items-center pr-[21px] gap-[20px]">
        <Button
          type="primary"
          size="large"
          icon={<Download className="w-[20px] h-[20px]" color="white" />}
          onClick={downloadReport}
        >
          PDF татах
        </Button>
      </div>
    </>
  );
};

export { LoanOfficer };
